import React from 'react';

import { useTranslation } from '../../translations';

interface Props {
    children: React.ReactNode;
}

const LoanAmount: React.FC<Props> = ({ children }) => {
    const translated = useTranslation();

    return (
        <div className="loan-account-view__balance-container">
            <dt className="screen-reader-text">{translated.loanOverview.disposible}</dt>
            <dd
                className="loan-account__amount"
                itemProp="amount"
                itemScope
                itemType="https://schema.org/MonetaryAmount"
            >
                {children}
            </dd>
        </div>
    );
};

export default LoanAmount;
